import { useEffect, useState } from 'react';
import {
	Box,
	Button,
	Grid,
} from '@mui/material';
import '../TableauObs/Summary/Summary.scss';
import { fetchFinOpsExecutiveSummary } from '../../service/service';
import '../FineOps/finops.scss';
import '../DataEstate/data-estate-dashboard.scss';
import ArrowIconGreen from '../../assets/growth arrow down_green.svg';
import ArrowIconRed from '../../assets/growth arrow up_red.svg';
import { formatNumberWithCommas, getPercentageOfTwoNumbers } from '../../utils/common-util';
import { useNavigate } from 'react-router-dom';
import WidgetCardContainer from 'components/Widgets/WidgetCardContainer';
import NumberWidget from 'components/Widgets/NumberWidget';
import ChartWidget from 'components/Widgets/ChartWidget';
import PieWidget from 'components/Widgets/PieWidget';
import ProgressChartWidget from 'components/Widgets/ProgressChart';
import PageHeader from 'components/Header/Page';
import DashboardIcon from '../../assets/material-symbols_dashboard.svg';
import ProgramFilter from 'components/Dropdown/ProgramFilter';
import SectorFilter from 'components/Dropdown/SectorFilter';
import UnderDevelopmentWidget from 'components/Widgets/UnderDevlopmentWidget';

const ExecutiveSummary = () => {
	const [programName, setProgramName] = useState('all');
	const [sectorName, setSectorName] = useState('all');
	const [lastSyncDate, setLastSyncDate] = useState('');
	const [dateInfo, setDateInfo] = useState<any>({ year: null, month: null });

	const [CloudCostYTD, SetCloudCostYTD] = useState('-');
	const [CloudCostMTD, SetCloudCostMTD] = useState('-');
	const [CostChange, SetCostChange] = useState('-');
	const [costGrowth, SetCostGrowth] = useState('-');
	const [chartTitle, setChartTitle] = useState('Top 10 Programs by Cost (YTD) by Environment');
	const [pieTitle, setPieTitle] = useState('Cost % Distribution Across Teams (YTD)');

	const [grafanaCloudCostTrendLoading, setGrafanaCloudCostTrendLoading] = useState(true);
	const [grafanaCloudCostTrendOptions, setGrafanaCloudCostTrendOptions] = useState<any>();
	const [grafanaProgramByCostByEnvironmentLoading, setProgramByCostByEnvironmentLoading] = useState(true);
	const [grafanaDATeamsLoading, setGrafanaDATeamsLoading] = useState(true);
	const [grafanaServicesByCostLoading, setGrafanaServicesByCostLoading] = useState(true);

	const [yoyTrendLoading, setYoYTrendLoading] = useState(true);
	const [yoyTrendOptions, setYoYTrendOptions] = useState<any>();
	const [isNoAnnualYoYTrend, setIsNoAnnualYoYTrend] = useState(false);

	const [, SetCloudCostTrendBubbleValue] = useState(0);
	const [, SetCloudCostTrendLastDec] = useState(0);
	const [, SetCloudCostTrendCurrent] = useState(0);
	const [isNoAnnualCloudCostTrend, setIsNoAnnualCloudCostTrend] = useState(false);

	const [programByCostByEnvData, setProgramByCostByEnvData] = useState<any>([]);
	const [programByCostByEnvNames, setProgramByCostByEnvNames] = useState<any>([]);
	const [programByCostByEnvSeriesData, setProgramByCostByEnvSeriesData] = useState<any>([]);
	const [serviceByCostSeriesData, setServiceByCostSeriesData] = useState<any>([]);
	const [DATeamsSeriesData, setDATeamsSeriesData] = useState<any>([]);

	const [ytdUnit, setYtdUnit] = useState('');
	const [mtdUnit, setMtdUnit] = useState('');

	const navigate = useNavigate();

	// sector filter
	const [sectorOptionsList, setSectorOptionsList] = useState<string[]>([]);
	const [programOptionsList, setProgramOptionsList] = useState<string[]>([]);
	
	async function fetchLastSyncData() {
		fetchFinOpsExecutiveSummary('lastSync')
		.then((res) => {
			let lastSyncData = res?.data?.result[0].REFRESHDATE ?? '';
			setLastSyncDate(lastSyncData);
			const refDate = new Date(res?.data?.result[0].refDate);
			const monthName = refDate.toLocaleString("en-US", { month: "long" });
            setDateInfo({
                year: refDate.getFullYear(),
                month: monthName, 
            });
		})
		.catch((error) => {
			console.error(error);
		});
	}

	async function fetchSectorOptionsData(filter: string, searchQuery?: string, filterBy?: any) {
		if (filter === 'Sectors') {
			const sectorRes = await fetchFinOpsExecutiveSummary('sector', filterBy);
			if (sectorRes.success) {
				if (filter === 'Sectors') {
					setSectorOptionsList(
						sectorRes.data.result.sort().map((x: any) => {
							return x;
						})
					);
				}
			}
		} else {
			const programRes = await fetchFinOpsExecutiveSummary('program', filterBy);
			if (programRes.success) {
					setProgramOptionsList(
						programRes.data.result.sort().map((x: any) => {
							return x;
						})
					);
				}
		}
	}

	const grafanaLoader = (value: boolean) => {
		setProgramByCostByEnvironmentLoading(value);
		setGrafanaCloudCostTrendLoading(value);
		setGrafanaServicesByCostLoading(value);
		setGrafanaDATeamsLoading(value);
		setYoYTrendLoading(value);
	}

	const handleSectorChange = async (value: string) => {
		grafanaLoader(true);
		setSectorName(value);
		setChartTitle('Top 10 Programs by Cost (YTD) by Environment');
		setPieTitle('Cost % Distribution Across Teams (YTD)');
		let prgName = programName;
		if(programName !== 'all' && value !== 'all') {
			const selectedProgram = {
				Program: [programName],
				Sector: [value]
			};
			prgName = await getExistProgram(selectedProgram);
		}
		getExecutiveDashboardDetails(prgName, value);
	};

	async function getExistProgram(selectedProgram: any): Promise<string> {
		const res = await fetchFinOpsExecutiveSummary('programexist', selectedProgram);
		return res.success && res.data.result.length > 0 ? programName : 'all';
	}

	const handleNavigateTeamDetails = (e: any) => {
		let programFilter = programName;
		let sectorFilter = sectorName;
		if (programFilter == 'EDF') return;

		let path = '/finops/details?programName=' + programFilter + '&sector=' + sectorFilter 
					+ '&team=' + e.name + '&year=' + dateInfo.year;
		navigate(path);
	};

	const handleNavigateServiceDetails = (e: any) => {
		if(e.name === 'OTHERS') return;
		let programFilter = programName;
		let sectorFilter = sectorName;
		let path = '/finops/details?programName=' + programFilter + '&sector=' + sectorFilter 
					+ '&consumedService=' + e.name + '&year=' + dateInfo.year;
		navigate(path);
	};

	const handleNavigateDetails = (param: any, fullProgramName: string) => {
		const envName = param.seriesName;
		let sectorFilter = sectorName;
		let environment = 'QA';
		if (envName == 'DEV') environment = 'Development';
		else if (envName == 'PROD') environment = 'Production';
		else if (envName == 'PREPROD') environment = 'Pre Production';
		else if (envName == 'SANDBOX') environment = 'Sandbox';
		else if (envName == 'UNKNOWN') environment = 'Unknown';
		let path = '/finops/details?programName=' + fullProgramName + '&environmentName=' 
				+ environment + '&sector=' + sectorFilter + '&year=' + dateInfo.year;
		navigate(path);
	};

	const handleDefault = () => {
		let path = '';
		let programFilter = programName;
		let sectorFilter = sectorName;

		path = '/finops/details?programName=' + programFilter + '&sector=' + sectorFilter + '&year=' + dateInfo.year;
		navigate(path);
	};

	const handleNavigatePrev = () => {
		const yearMonthList = getPreviousMonths(2);
		let path = '';
		let programFilter = programName;
		let sectorFilter = sectorName;
		path = '/finops/details?programName=' + programFilter + '&sector=' + sectorFilter + '&year='+ yearMonthList.years + '&month=' + yearMonthList.months + '&lmcg='+ true;;
		navigate(path);
	};

	const handleNavigateByDate = (isMTD: any) => {
		let path = '';
		let programFilter = programName;
		let sectorFilter = sectorName;
		path = '/finops/details?programName=' + programFilter + '&sector=' + sectorFilter + '&year='+ dateInfo.year;
		if(isMTD)
			path = path + '&month=' + dateInfo.month;

		navigate(path);
	};

	function formatNumber(number: any) {
		if (number != null && !isNaN(number)) {
			return Number(number).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		} else {
			return '0.00';
		}
	}

	function formatAbsNumber(number: any) {
		if (number != null && !isNaN(number) && number != 0) {
			return Number(Math.abs(number)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		} else {
			return '0';
		}
	}

	const formatNumberByUnits = (number: number, isYtd : boolean = false) => {
		if (number >= 1000000) {
			if(isYtd) {
				setYtdUnit('MM')
			}
			else {
				setMtdUnit('MM')
			}
			return `${new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
				number / 1000000
			)}`;
		}
		if (number >= 1000) {
			if(isYtd) {
				setYtdUnit('K')
			}
			else {
				setMtdUnit('K')
			}
			return `${formatNumberWithCommas((number / 1000).toFixed(2), true)}`;
		}
		return new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(number);
	};

	const getPreviousMonths = (numMonths: number) => {
		const currentDate = new Date();
		const monthNames = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December'
		];
		const returnList = {
			months: [] as string[],
			years: [] as number[]
		};
		for (let i = 1; i <= numMonths; i++) {
			let date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
			if (numMonths == 1) date = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
			const month = date.getMonth();
			const year = date.getFullYear();
			returnList.months.push(monthNames[month]);
			if (!returnList.years.includes(year)) 
				returnList.years.push(year);
		}
		return returnList;
	};

	async function getExecutiveDashboardDetails(
		prgName: any,
		sector: any,
		isProgramChange: boolean = false
	) {
		// ---------- Reset states ----------
		SetCloudCostYTD('-');
		SetCloudCostMTD('-');
		SetCostChange('-');
		SetCostGrowth('-');
		setYtdUnit('');
		setMtdUnit('');

		const selectedProgram = {
			Program: [prgName],
			Sector: [sector],
		};

		try {
			// ---------- API calls ----------
			const sectorPromise =
			isProgramChange && prgName !== 'all'
				? fetchFinOpsExecutiveSummary('sector', selectedProgram)
				: Promise.resolve({ data: { result: [] } }); // dummy response for others

			const [
			sectorRes,
			programRes,
			ytdRes,
			mtdRes,
			momRes,
			lmcgRes,
			trendRes,
			programCostRes,
			serviceCostRes,
			teamCostRes,
			yoyTrendRes,
			] = await Promise.all([
			sectorPromise,
			fetchFinOpsExecutiveSummary('program', selectedProgram),
			fetchFinOpsExecutiveSummary('ytd', selectedProgram),
			fetchFinOpsExecutiveSummary('mtd', selectedProgram),
			fetchFinOpsExecutiveSummary('mom', selectedProgram),
			fetchFinOpsExecutiveSummary('lmcg', selectedProgram),
			fetchFinOpsExecutiveSummary('trend', selectedProgram),
			fetchFinOpsExecutiveSummary('programcost', selectedProgram),
			fetchFinOpsExecutiveSummary('servicecost', selectedProgram),
			prgName !== 'EDF'
				? fetchFinOpsExecutiveSummary('teamcost', selectedProgram)
				: Promise.resolve(null),
			fetchFinOpsExecutiveSummary('yoyTrend', selectedProgram),
			]);

			// ---------- Sector ----------
			if (isProgramChange && prgName !== 'all') {
			setSectorOptionsList(sectorRes.data.result.sort());
			}

			// ---------- Program ----------
			const programOptions = programRes.data.result.sort();
			setProgramOptionsList(programOptions);

			if (!programOptions.includes(prgName)) {
			selectedProgram.Program = ['all'];
			setProgramName('all');
			}

			// ---------- KPI helpers ----------
			const getKpiValue = (res: any) => res?.data?.result?.[0]?.KPI_VALUE ?? 0;

			SetCloudCostYTD(formatNumberByUnits(getKpiValue(ytdRes), true));
			SetCloudCostMTD(formatNumberByUnits(getKpiValue(mtdRes)));
			SetCostGrowth(getKpiValue(momRes).toString());
			SetCostChange(getKpiValue(lmcgRes).toString());

			// ---------- Trend helpers ----------
			const processTrend = (
			data: Record<string, number>,
			setNoTrend: (v: boolean) => void,
			onBubble?: (prev: number, curr: number) => void
			) => {
			let currentMonth = new Date().getMonth();
			if (currentMonth === 0) currentMonth = 12;

			const year = new Date().getFullYear();
			const month = currentMonth.toString().padStart(2, '0');

			const prevKey = `${year - 1}-${month}`;
			const currKey = `${year}-${month}`;

			const prev = data[prevKey];
			const curr = data[currKey];

			if (prev !== undefined && curr !== undefined) {
				setNoTrend(false);
				onBubble?.(prev, curr);
			}
			};

			// ---------- Cloud cost trend ----------
			if (trendRes?.data?.result) {
			processTrend(
				trendRes.data.result,
				setIsNoAnnualCloudCostTrend,
				(prev, curr) => {
				SetCloudCostTrendLastDec(prev);
				SetCloudCostTrendCurrent(curr);
				SetCloudCostTrendBubbleValue(
					getPercentageOfTwoNumbers(prev, curr)
				);
				}
			);

			setGrafanaCloudCostTrendOptions(trendRes.data.result);
			setGrafanaCloudCostTrendLoading(false);
			}

			// ---------- YoY trend ----------
			if (yoyTrendRes?.data?.result) {
			processTrend(
				yoyTrendRes.data.result,
				setIsNoAnnualYoYTrend
			);

			setYoYTrendOptions(yoyTrendRes.data.result);
			setYoYTrendLoading(false);
			}

			// ---------- Program cost by environment ----------
			const programCostData = programCostRes?.data?.result || [];

			const envNames =
			programCostData.length > 0
				? Object.keys(programCostData[0]).filter(
					(k) => k !== 'programname' && k !== 'total_cost'
				)
				: [];

			const maxTotalCost = Math.max(
			...programCostData.map((i: any) => i.total_cost)
			);
			const localMaxTotalCost = maxTotalCost + maxTotalCost * 0.15;

			const buildTotalLabel = (idx: number) => {
			const cost = programCostData[programCostData.length - 1 - idx].total_cost;
			const formattedValue =
			cost >= 1_000_000
				? formatNumber(cost / 1_000_000) + 'MM'
				: formatNumber(cost / 1_000) + 'K';

			return '$' + formattedValue;
			};

			const envSeriesData = envNames.map((env, index) => ({
			name: env.toUpperCase(),
			type: 'bar',
			stack: 'total',
			showBackground: true,
			backgroundStyle: { color: '#174377' },
			label: {
				show: index === envNames.length - 1,
				position: 'right',
				color: '#F5F5F5',
				formatter: ({ dataIndex }: any) => buildTotalLabel(dataIndex),
			},
			data: programCostData.map((i: any) => i[env]).reverse(),
			}));

			const totalCostSeries = {
			name: 'TOTAL_COST',
			type: 'bar',
			stack: 'total',
			itemStyle: { color: 'transparent' },
			emphasis: { itemStyle: { color: 'transparent' } },
			data: [...programCostData.map((i: any) => i.total_cost), localMaxTotalCost],
			};

			setProgramByCostByEnvNames(envNames);
			setProgramByCostByEnvData(programCostData);
			setProgramByCostByEnvSeriesData(
			programCostData.length ? [...envSeriesData, totalCostSeries] : []
			);
			setProgramByCostByEnvironmentLoading(false);

			// ---------- Service cost ----------
			let serviceSeries =
			serviceCostRes?.data?.result?.map((i: any) => ({
				name: i.consumedservice,
				value: i.total_cost,
				formattedName: `${i.percentage || 0}%`,
			})) || [];

			const others = serviceSeries.filter((i: any) => i.name === 'Others');
			serviceSeries = serviceSeries.filter((i: any) => i.name !== 'Others').concat(others);

			setServiceByCostSeriesData(serviceSeries);
			setGrafanaServicesByCostLoading(false);

			// ---------- Team cost ----------
			if (teamCostRes) {
			const teamSeries =
				teamCostRes.data.result
				?.map((i: any) => ({
					name: i.team,
					value: i.total_cost,
					formattedName: `${i.percentage || 0}%`,
				}))
				.sort((a: any, b: any) => a.name.localeCompare(b.name)) || [];

			setDATeamsSeriesData(teamSeries);
			setGrafanaDATeamsLoading(false);
			}
		} catch (error) {
			console.error('Error fetching executive dashboard details:', error);
		}
		}

	useEffect(() => {
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/finops/executive-dashboard') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list');
				activeId.classList.remove('root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas');
				document.body.classList.add('datefilter-align-sector');
				document.body.classList.add('sector-label');
				document.body.classList.add('program-arrow');
			}
		} else {
			if (activeId) {
				document.body.classList.remove('jobs-list-datas');
				activeId.classList.add('root');
				document.body.classList.add('datefilter-align-sector');
			}
		}

		fetchLastSyncData();
		fetchSectorOptionsData('Sectors');
		getExecutiveDashboardDetails(programName, 'all');
	}, []);

	const handleProgramInputChange = (value: string) => {
		const newValue = value;
		setProgramName(newValue);
	}

	// Clear 
	const handleClearFilters = () => {
		setProgramName('all');
		setSectorName('all');
		setChartTitle('Top 10 Programs by Cost (YTD) by Environment');
		setPieTitle('Cost % Distribution Across Teams (YTD)');
		fetchLastSyncData();
		fetchSectorOptionsData('Sectors');
		getExecutiveDashboardDetails('all', 'all');
	};

	const handleProgramChange = (selectedOption: any) => {
		const newValue = selectedOption?.value ?? ''
		grafanaLoader(true);
		setProgramName(newValue);
		let programNameArr = programOptionsList.filter((program: any) => program == newValue)
		
		// Set the title based on the selected program(s)		
		if (newValue === 'all') {
			setChartTitle('Top 10 Programs by Cost (YTD) by Environment');
		} else {
			setChartTitle('Cost by Environment');
		}

		setPieTitle(newValue === 'EDF' 
			? 'Cost % Distribution Across Sectors (YTD)' 
			: 'Cost % Distribution Across Teams (YTD)'
		);

		if((programNameArr.length > 0 || newValue == 'all')) {
			getExecutiveDashboardDetails(newValue, sectorName, true);
		}
	}
	const getTrendMeta = (value: string | null | undefined) => {
		if (value === null || value === undefined || value === '-') {
			return {
			unitIcon: null,
			color: 'white',
			};
		}

		const parsedValue = parseFloat(value);

		if (parsedValue === 0) {
			return {
			unitIcon: null,
			color: 'white',
			};
		}

		return {
			unitIcon: parsedValue > 0 ? ArrowIconRed : ArrowIconGreen,
			color: parsedValue < 0 ? 'success.main' : 'error.main',
		};
	};
	const costGrowthTrend = getTrendMeta(costGrowth);
	const costChangeTrend = getTrendMeta(CostChange);



	return (
		<Box mt="80px" bgcolor='backgroundLight.primary'>	
			<PageHeader title={[]} icon={DashboardIcon} lastSync={lastSyncDate} isDataRefresh={true}>
				{(programName !== 'all' || sectorName !== 'all') && (
					<Button
						variant="text"
						color="primary"
						sx={{
							fontWeight: 'bold',
							fontSize: '16px',
							color: '#003771 !important',
							textTransform: 'none',
							cursor: 'pointer',
							'&:hover': {
								background: 'transparent !important',
							},
						}}
						onClick={handleClearFilters}
					>
						Clear Filters
					</Button>
				)}
				<ProgramFilter 
					handleChange={handleProgramChange} 
					handleProgramInputChange = {handleProgramInputChange}
					programName={programName}
					setProgramName={setProgramName}
					programOptionsList={programOptionsList} />
				<SectorFilter 
					sectorName={sectorName}
					setSectorName={setSectorName}
					sectorOptionsList={sectorOptionsList}
					handleChange={handleSectorChange} />
			</PageHeader>
			<WidgetCardContainer title="Cost Summary">
				<Grid container spacing={1} m={0}>
					<Grid item container spacing={1} xs={12} md={5}>
						<Grid item xs={12} lg={6}>
							<NumberWidget
								title="Azure Cloud Cost (YTD)"
								number={'$' + CloudCostYTD}
								isLoading={CloudCostYTD === '-'}
								tooltipLabel={''}
								hasTooltip={false}
								units={ytdUnit}
								handleEvent={() => handleNavigateByDate(false)}
							/>
						</Grid>
						<Grid item xs={12} lg={6}>
							<NumberWidget
								title="Azure Cloud Cost (MTD)"
								number={'$' + CloudCostMTD}
								isLoading={CloudCostMTD === '-'}
								tooltipLabel={''}
								hasTooltip={false}
								units={mtdUnit}
								handleEvent={() => handleNavigateByDate(true)}
							/>
						</Grid>
						<Grid item xs={12} lg={6}>
							<NumberWidget
								title="Average Cost Growth (MOM)"
								number={formatAbsNumber(costGrowth)}
								isLoading={costGrowth === '-'}
								tooltipLabel={''}
								hasTooltip={false}
								units="%"
								unitIcon={costGrowthTrend.unitIcon}
  								color={costGrowthTrend.color}
								// unitIcon={
								// 	!costGrowth && parseFloat(costGrowth) != 0.0
								// 		? parseFloat(costGrowth) > 0.0
								// 			? ArrowIcon
								// 			: ArrowIconRed
								// 		: null
								// }
								// // unitIcon={costGrowth && parseFloat(costGrowth) != 0 ? (parseFloat(costGrowth) > 0 ? ArrowIcon : ArrowIconRed) : null}
								//color={parseFloat(costGrowth) != 0.0 ? (parseFloat(costGrowth) < 0.0 ? 'error.main' : 'success.main'): undefined}
								// handleEvent={() => handleSetComponent('MAJOR_INCIDENTS_LAST_MONTH', {
								handleEvent={() => handleNavigateByDate(false)}
							/>
						</Grid>
						<Grid item xs={12} lg={6}>
							<NumberWidget
								title="Cost Change Compared to Last Month"
								number={formatAbsNumber(CostChange)}
								isLoading={CostChange === '-'}
								tooltipLabel={''}
								hasTooltip={false}
								units="%"
								unitIcon={costChangeTrend.unitIcon}
  								color={costChangeTrend.color}
								//unitIcon={CostChange ? (parseFloat(CostChange) > 0 ? ArrowIcon : ArrowIconRed) : null}
								//color={parseFloat(CostChange) < 0 ? 'error.main' : 'success.main'}
								handleEvent={handleNavigatePrev} // handleEvent={() => handleSetComponent('MAJOR_INCIDENTS_LAST_MONTH', {
							/>
						</Grid>
					</Grid>
					{/* right side */}
					<Grid item container spacing={1} xs={12} md={7}>
						<Grid item xs={12} lg={7}>
							<ChartWidget
								title="Azure Cloud Cost Trend (MOM)"
								minTitleHeight="40px"
								data={grafanaCloudCostTrendOptions}
								hasBadge={!grafanaCloudCostTrendLoading && !isNoAnnualCloudCostTrend ? true : false}
								isLoading={grafanaCloudCostTrendLoading}
								handleEvent={handleDefault}
								conversionUnitProp="cost"
								isFinops
							/>
						</Grid>
						<Grid item xs={12} lg={5}>
							<ChartWidget
								title="Azure Cloud Cost Trend (YOY)"
								minTitleHeight="40px"
								data={yoyTrendOptions}
								hasBadge={!yoyTrendLoading && !isNoAnnualYoYTrend ? true : false}
								isLoading={yoyTrendLoading}
								handleEvent={handleDefault}
								conversionUnitProp="cost"
								isYearly
								isFinops
							/>
						</Grid>
					</Grid>
				</Grid>
			</WidgetCardContainer>
			{/* second part */}
			<Grid item container mt={2} xs={12}>
				<WidgetCardContainer title="Cost Breakdown">
					<Grid container spacing={1}>
						<Grid item xs={12} md={4}>
							<ProgressChartWidget
								title={chartTitle}
								data={programByCostByEnvData}
								envNames={programByCostByEnvNames}
								seriesData={programByCostByEnvSeriesData}
								isLoading={grafanaProgramByCostByEnvironmentLoading}
								handleEvent={handleNavigateDetails}
							/>
						</Grid>
						<Grid item xs={12} md={4}>
							<PieWidget
								title="Top Services by Cost (YTD)"
								isLoading={grafanaServicesByCostLoading}
								seriesData={serviceByCostSeriesData}
								handleEvent={handleNavigateServiceDetails}
							/>
						</Grid>
						<Grid item xs={12} md={4}>
							{programName === 'EDF' ? 
							<UnderDevelopmentWidget title="Cost % Distribution Across Sectors (YTD)" />
							:<PieWidget
								title={pieTitle}
								isLoading={grafanaDATeamsLoading}
								seriesData={DATeamsSeriesData}
								handleEvent={handleNavigateTeamDetails}
							/>}
						</Grid>
					</Grid>
				</WidgetCardContainer>
			</Grid>			
		</Box>
	);
};

export default ExecutiveSummary;
